import React from "react";
import { get } from "lodash";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import FlatButton from "material-ui/FlatButton";
import IconButton from "material-ui/IconButton";
import Input from "@material-ui/core/Input";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MomentUtils from "@date-io/moment";
import { withStyles } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider, DatePicker } from "material-ui-pickers";

import { CATEGORIES_LIST, CATEGORIES_LIST_HE } from "../../fixtures/categories";

import {
  getIssueStatus,
  ISSUE_STATE_CLOSED,
  ISSUE_STATE_RESOLVED,
  ISSUE_STATE_OPENED
} from "../../utils/issues.js";
import {FileStackClient, getImagePreviewUrl, getFilePreviewUrl} from "../../services/FileStackService";
import uuid from "uuid";
import RemoveIcon from "material-ui/svg-icons/action/delete";

const statusList = [
  ISSUE_STATE_CLOSED,
  ISSUE_STATE_RESOLVED,
  ISSUE_STATE_OPENED
];

const CATEGORIES_LIST_LOCAL =
  navigator.language.includes('he') ? CATEGORIES_LIST_HE : CATEGORIES_LIST;

const styles = theme => ({
  formControl: {
    minWidth: 120
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  },
  chips: {
    display: "flex",
    flexWrap: "wrap"
  },
  chip: {
    margin: theme.spacing.unit / 4
  }
});

class Form extends React.Component {
  constructor(props) {
    super();
    this.state = {
      title: props.title || "",
      categories: props.categories ? props.categories[0] : "-1",
      assignTo: get(props, 'assignTo.id') || null,
      dueDate: props.dueDate || null,
      cost: props.cost || "",
      schedule: props.schedule || "",
      tagged: Object.keys(props.tagged || {}),
      issueState: props.issueState || 300,
      checklistItemName: props.checklistItemName || '',
      images: props.images || {},
      location: props.location || null,
      floorName: props.location && props.location.floor ? props.location.floor.name : undefined
    };
    this.categories = Object.values(CATEGORIES_LIST_LOCAL);
  }

  onChanger = name => e => this.setState({ [name]: e.target.value });

  onTitle = this.onChanger("title");
  onCost = this.onChanger("cost");
  onSchedule = this.onChanger("schedule");
  onAssignTo = this.onChanger("assignTo");
  onCategory = this.onChanger("categories");
  onStatus = this.onChanger("issueState");

  onFloorChange = (e) => {
    this.setState({ floorName: e.target.value, location: null });
  }

  onUnitChange = (e) => {
    const { locations } = this.props
    const building = locations ? Object.values(locations)[0] : false;
    const items = Object.values(building.items)[0];
    const floor = Object.values(items.floor).find(f=>f.name=this.state.floorName);
    const selectedUnit = items.unit[e.target.value];

    const location = {
      building: {
        id: items.id,
        name: items.name,
      },
      floor,
      unit: {
        id: selectedUnit.id,
        name: selectedUnit.name,
        floorName: selectedUnit.floorName
      },
      projectSettings: building.locationSettings
    }

    this.setState({ location });
  }

  onDate = date => this.setState({ dueDate: date });

  onTagged = e => {
    this.setState({ tagged: [...e.target.value] });
  };

  removeFile = (id) => {
    const images = {...this.state.images };

    if (images[id]) {
      delete images[id]
    }

    this.setState({images});


  };

  renderFiles = () => {
    const { images } = this.state;


    const files = Object.values(images);

    if (files.length === 0) {
      return null;
    }

    return (
      <div>
        <ul>
          {files.map(f => {

            const imageSrc = f.type === 'photo'
                ? getImagePreviewUrl(f.filestackId, 300, 300)
                : getFilePreviewUrl(f.filestackId, 300, 300);
            const previewStyle = { backgroundImage: `url(${imageSrc})`, backgroundSize: 'cover' };

            return (
                <li key={f.id} className="attach-list-item">
                  <div className="image" style={previewStyle}/>

                  <span>{f.name}</span>

                  <IconButton
                      onClick={() => this.removeFile(f.id)}
                  >
                    <RemoveIcon style={{marginTop: 10}} />
                  </IconButton>

                </li>
            );
          })}
        </ul>
      </div>
    )
  }

  _handleUpload = () => {
    FileStackClient.picker({
      maxFiles: 20,
      fromSources: [
        "local_file_system",
        "googledrive",
        "dropbox",
        "gmail",
        "box",
        "onedrive",
        "clouddrive"
      ],
      onUploadDone: (res) => {
        const { filesUploaded } = res;
        const images = {...this.state.images };

        const now = new Date().getTime();

        filesUploaded.forEach(file => {
          const id = uuid.v4();

          const type = file.filename && file.filename.match(/\.(jpeg|jpg|gif|png|JPG|PNG|GIF|JPEG)$/) != null ? 'photo' : 'document';

          images[id] = {
            id: id,
            createdAt: now,
            updatedAt: now,
            categories: {},
            sharedWith: [],
            owner: '', //get user id
            issues: [], //get message id
            name: file.filename,
            metadata: {
              mimetype: file.mimetype
            },
            filestackId: file.handle,
            type: type,
            uri: file.url,
            folder: type === 'document' ? 'Plans' : 'Photos',
            location: null,

            shouldSave: true //remove it
          }
        });

        this.setState({ images });
      }
    }).open();
  };

  getFloors = () => {
    const { locations } = this.props

    if (!locations) {
      return []
    }

    const building = locations ? Object.values(locations)[0] : false;

    if (!building) {
      return [];
    }

    const items = Object.values(building.items)[0];

    return Object.values(items.floor);
  }

  getUnitBySelectedFloor = () => {
    const { floorName } = this.state

    if (!floorName) {
      return [];
    }

    const { locations } = this.props

    if (!locations) {
      return []
    }

    const building = locations ? Object.values(locations)[0] : false;

    if (!building) {
      return [];
    }

    const items = Object.values(building.items)[0];

    const units = Object.values(items.unit);

    return units.filter(u => u.floorName === floorName);
  }

  render() {
    const {
      categories,
      title,
      assignTo,
      dueDate,
      cost,
      schedule,
      tagged,
      issueState,
      checklistItemName,
      location
    } = this.state;
    const { classes, members, onConfirm, onClose, onDelete, id, onStartUpload } = this.props;

    // const units = building ? Object.values(building.items).unit : [];
    // const floors = locations ? Object.values(Object.values(locations.items)[0].floor) : [];


    const listMembers = Object.values(members || {});

    return (
      <div style={{ padding: "25px" }}>
        <form autoComplete="off">
          <div className="issue-form-wrap">
            <div className="issue-form__item">
              <FormControl fullWidth className={classes.formControl}>
                <TextField
                  disabled={true}
                  multiline
                  fullWidth
                  type="text"
                  // onChange={this.onTitle}
                  value={checklistItemName}
                  label="Checklist item"
                />
              </FormControl>
            </div>
            <div className="issue-form__item">
              <FormControl fullWidth className={classes.formControl}>
                <select
                    name="location"
                    className="select-text"
                    value={location ? location.floor.name : undefined}
                    onChange={this.onFloorChange}
                    disabled={id && location}
                >
                  <option key={"key"} value="">
                    Select floor
                  </option>
                  {this.getFloors().map(floor => (
                      <option key={floor.id} value={floor.name}>
                        {floor.name}
                      </option>
                  ))}
                </select>
              </FormControl>
              <FormControl fullWidth className={classes.formControl}>
                <select
                    name="location"
                    className="select-text"
                    value={location ? location.unit.id : undefined}
                    disabled={id && location}
                    onChange={this.onUnitChange}
                >
                  <option key={"key"} value="">
                    Select unit
                  </option>
                  {this.getUnitBySelectedFloor().map(unit => (
                      <option key={unit.id} value={unit.id}>
                        {unit.name}
                      </option>
                  ))}
                </select>
              </FormControl>
            </div>
          </div>
          <div className="issue-form-wrap">
            <div className="issue-form__item">
              <FormControl fullWidth className={classes.formControl}>
                <TextField
                  multiline
                  fullWidth
                  type="text"
                  onChange={this.onTitle}
                  value={title}
                  label="Description"
                />
              </FormControl>
            </div>
            <div className="issue-form__item">
              <FormControl fullWidth className={classes.formControl}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <DatePicker
                    label="Due date"
                    margin="normal"
                    value={dueDate}
                    onChange={this.onDate}
                  />
                </MuiPickersUtilsProvider>
              </FormControl>
            </div>
          </div>
          <div className="issue-form-wrap">
            <div className="issue-form__item">
              <FormControl fullWidth className={classes.formControl}>
                <TextField
                  fullWidth
                  type="number"
                  onChange={this.onCost}
                  value={cost}
                  label="Cost Impact"
                />
              </FormControl>
            </div>
            <div className="issue-form__item">
              <FormControl fullWidth className={classes.formControl}>
                <TextField
                  fullWidth
                  type="number"
                  onChange={this.onSchedule}
                  value={schedule}
                  label="Schedule impact"
                />
              </FormControl>
            </div>
          </div>
          <div className="issue-form-wrap">
            <div className="issue-form__item">
              <FormControl fullWidth className={classes.formControl}>
                <InputLabel htmlFor="category">Category</InputLabel>
                <Select
                  value={categories}
                  onChange={this.onCategory}
                  inputProps={{
                    name: "category",
                    id: "category"
                  }}
                >
                  <MenuItem key={"item_key_0"} value="-1">
                    <em>None</em>
                  </MenuItem>
                  {this.categories.map(category => (
                    <MenuItem key={category.id} value={category.id}>
                      {category.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="issue-form__item">
              <FormControl fullWidth className={classes.formControl}>
                <InputLabel htmlFor="assign">Assign to</InputLabel>
                <Select
                  value={assignTo || get(listMembers, "[0].id")}
                  onChange={this.onAssignTo}
                  input={<Input id="select-multiple-chip" />}
                  inputProps={{
                    name: "assign",
                    id: "assign"
                  }}
                >
                  {listMembers.map(member => (
                    <MenuItem key={member.id} value={member.id}>
                      {member.displayName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
          <div className="issue-form-wrap">
            <div className="issue-form__item">
              <FormControl fullWidth className={classes.formControl}>
                <InputLabel htmlFor="assign">Share with:</InputLabel>
                <Select
                  multiple
                  value={tagged || []}
                  onChange={this.onTagged}
                  input={<Input id="select-multiple-chip" />}
                  inputProps={{
                    name: "tagged",
                    id: "tagged"
                  }}
                  renderValue={selected => (
                    <div className={classes.chips}>
                      {selected.map(value => (
                        <Chip
                          key={value}
                          label={get(members, `[${value}].displayName`)}
                          className={classes.chip}
                        />
                      ))}
                    </div>
                  )}
                >
                  {listMembers.map(member => (
                    <MenuItem key={member.id} value={member.id}>
                      {member.displayName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            {id && (
              <div className="issue-form__item">
                <FormControl fullWidth className={classes.formControl}>
                  <InputLabel htmlFor="assign">Status:</InputLabel>
                  <Select value={issueState} onChange={this.onStatus}>
                    {statusList.map(status => (
                      <MenuItem key={status} value={status}>
                        {getIssueStatus(status)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            )}
          </div>

          <div>
            <FlatButton
                label="attach photo/file"
                backgroundColor="#ef5350"
                labelStyle={{ color: "#fff" }}
                hoverColor="#f44336"
                onClick={this._handleUpload}
                style={{ marginRight: "10px" }}
            />
          </div>


          {this.renderFiles()}
        </form>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <FlatButton
            label="delete"
            backgroundColor="#ef5350"
            labelStyle={{ color: "#fff" }}
            hoverColor="#f44336"
            onClick={onDelete}
            style={{ marginRight: "10px" }}
          />
          <FlatButton
            label="Cancel"
            backgroundColor="#78909C"
            labelStyle={{ color: "#fff" }}
            hoverColor="#607D8B"
            onClick={onClose}
            style={{ marginRight: "10px" }}
          />
          <FlatButton
            label="Save"
            backgroundColor="#4CAF50"
            labelStyle={{ color: "#fff" }}
            hoverColor="#43A047"
            onClick={() => onConfirm(this.state)}
            style={{ marginRight: "10px" }}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Form);
